(function () {
  'use strict';

  const MOBILE_BREAKPOINT = 999;
  let modal = null;
  let modalBody = null;
  let loader = null;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function getModal() {
    if (!modal) {
      modal = document.getElementById('quick-atc-modal');
      modalBody = modal.querySelector('.quick-atc-modal__body');
      loader = modal.querySelector('.quick-atc-modal__loader');
    }
    return modal;
  }

  function openModal() {
    let m = getModal();
    m.classList.add('quick-atc-modal--open');
    m.setAttribute('aria-hidden', 'false');
  }

  function closeModal() {
    var m = getModal();
    m.classList.remove('quick-atc-modal--open');
    m.setAttribute('aria-hidden', 'true');
    setTimeout(function () {
      modalBody.innerHTML = '';
    }, 300);
  }

  function showLoader() {
    getModal();
    loader.classList.add('quick-atc-modal__loader--visible');
    modal.querySelector('.quick-atc-modal__content').classList.add('quick-atc-modal__content--loading');
  }

  function hideLoader() {
    loader.classList.remove('quick-atc-modal__loader--visible');
    modal.querySelector('.quick-atc-modal__content').classList.remove('quick-atc-modal__content--loading');
  }

  async function loadContent(handle) {
    openModal();
    showLoader();

    try {
      var url = window.themeVariables.routes.rootUrlWithoutSlash
        + '/products/' + handle + '?view=quick-atc';
      var response = await fetch(url);

      if (!response.ok) throw new Error('HTTP ' + response.status);

      var html = await response.text();
      var div = document.createElement('div');
      div.innerHTML = html;

      var sectionContent = div.querySelector('.quick-atc');
      if (!sectionContent) throw new Error('Missing .quick-atc in response');

      modalBody.innerHTML = '';
      modalBody.appendChild(sectionContent);
      postProcess(modalBody);
    } catch (err) {
      console.error('[quick-atc] Failed to load content:', err);
      closeModal();
      window.location.href = window.themeVariables.routes.rootUrlWithoutSlash
        + '/products/' + handle;
    } finally {
      hideLoader();
    }
  }

  var COLOR_LABELS = ['farbe', 'color', 'colour', 'couleur'];

  function postProcess(container) {
    fixRevealOnScroll(container);
    hideColorOption(container);
    initSliderArrows(container);
    initSwatchNavArrows(container);
    initReviews(container);
    setupRestockRocket(container);
  }

  function updateSwatchNavArrows(swatchesEl) {
    var list = swatchesEl.querySelector('.quick-atc-swatches__list');
    if (!list) return;
    var nav = swatchesEl.querySelector('.quick-atc-swatches__nav');
    var prevBtn = swatchesEl.querySelector('[data-swatch-nav="prev"]');
    var nextBtn = swatchesEl.querySelector('[data-swatch-nav="next"]');
    if (!prevBtn || !nextBtn) return;
    var canScroll = list.scrollWidth > list.clientWidth + 1;
    if (nav) nav.style.display = canScroll ? '' : 'none';
    if (!canScroll) return;
    var atLeft = list.scrollLeft <= 1;
    var atRight = list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
    prevBtn.classList.toggle('quick-atc-swatches__nav-btn--disabled', atLeft);
    nextBtn.classList.toggle('quick-atc-swatches__nav-btn--disabled', atRight);
  }

  function initSwatchNavArrows(container) {
    var swatchesEl = container.querySelector('.quick-atc-swatches');
    if (!swatchesEl) return;
    updateSwatchNavArrows(swatchesEl);
    var list = swatchesEl.querySelector('.quick-atc-swatches__list');
    if (list) {
      list.addEventListener('scroll', function () {
        updateSwatchNavArrows(swatchesEl);
      });
    }
  }

  function fixRevealOnScroll(container) {
    var media = container.querySelector('product-media');
    if (media) {
      media.removeAttribute('reveal-on-scroll');
    }
    container.querySelectorAll('[reveal]').forEach(function (el) {
      el.removeAttribute('reveal');
    });
  }

  function hideColorOption(container) {
    var selectors = container.querySelectorAll('.product-form__option-selector');
    selectors.forEach(function (sel) {
      var nameEl = sel.querySelector('.product-form__option-name');
      if (nameEl) {
        var name = nameEl.textContent.replace(':', '').trim().toLowerCase();
        if (COLOR_LABELS.indexOf(name) !== -1) {
          sel.classList.add('product-form__option-selector--hide-color');
        }
      }
    });
  }

  function initSliderArrows(container) {
    if (isMobile()) return;

    var carouselEl = container.querySelector('flickity-carousel');
    if (!carouselEl) return;

    var wrapper = container.querySelector('.product__media-list-wrapper');
    if (!wrapper || wrapper.querySelector('.quick-atc-arrow')) return;

    function tryInit(attempts) {
      if (attempts <= 0) return;
      carouselEl.flickityInstance.then(function (flkty) {
        if (!flkty) {
          setTimeout(function () { tryInit(attempts - 1); }, 200);
          return;
        }
        createArrows(flkty, wrapper);
      });
    }

    tryInit(25);
  }

  function createArrows(flkty, wrapper) {
    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'quick-atc-arrow quick-atc-arrow--prev quick-atc-arrow--hidden';
    prevBtn.innerHTML = '<svg focusable="false" width="17" height="14" viewBox="0 0 17 14"><path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg>';

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'quick-atc-arrow quick-atc-arrow--next';
    nextBtn.innerHTML = '<svg focusable="false" width="17" height="14" viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg>';

    wrapper.appendChild(prevBtn);
    wrapper.appendChild(nextBtn);

    function updateArrows() {
      var idx = flkty.selectedIndex;
      var last = flkty.slides.length - 1;
      prevBtn.classList.toggle('quick-atc-arrow--hidden', idx === 0);
      nextBtn.classList.toggle('quick-atc-arrow--hidden', idx >= last);
    }

    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      flkty.previous();
    });
    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      flkty.next();
    });
    flkty.on('change', updateArrows);
    updateArrows();
  }

  function initReviews(container) {
    if (typeof window.ratingSnippet !== 'function') return;

    // POP-807: start from the app block config so its label/bracket settings survive this re-render.
    var ratingConfig = window.ratingSnippetGlobalSettings;
    var ratingOptions = Object.assign({}, ratingConfig && ratingConfig.options, {
      store: window.__REVIEWSIO_RATING_SNIPPET_STORE_OVERRIDE__ || window.reviewsIoStore,
      color: '#fa4616',
      linebreak: false,
      text_color: '#313131',
      font_size: '14px'
    });

    window.ratingSnippet((ratingConfig && ratingConfig.class) || 'ruk_rating_snippet', ratingOptions);

    patchBewertungenLabel(container);
  }

  function patchBewertungenLabel(container) {
    var patched = 0;
    var expected = container.querySelectorAll('.ruk_rating_snippet').length || 1;

    var observer = new MutationObserver(function () {
      var countEls = container.querySelectorAll('.ruk-rating-snippet-count');
      countEls.forEach(function (countEl) {
        var text = countEl.textContent.trim();
        if (!text || text.includes('Bewertungen')) return;
        var num = text.replace(/\D/g, '');
        if (num) {
          countEl.textContent = '(' + num + ' Bewertungen)';
          patched++;
        }
      });
      if (patched >= expected) observer.disconnect();
    });
    observer.observe(container, { childList: true, subtree: true, characterData: true });
    setTimeout(function () { observer.disconnect(); }, 5000);
  }

  async function setupRestockRocket(container) {
    if (!window._RestockRocket || !window._RestockRocketConfig) return;

    var form = container.querySelector('form[is="product-form"]');
    if (!form) return;

    var quickAtc = container.querySelector('.quick-atc');
    var handle = quickAtc ? quickAtc.getAttribute('data-product-handle') : null;
    if (!handle) return;

    try {
      var productRes = await fetch('/products/' + handle + '.js');
      var productData = await productRes.json();
      window._RestockRocketConfig.product = productData;
      window._RestockRocketConfig.selected_variant_id = productData.variants[0].id;
      window._RestockRocketConfig.selected_variant_available = productData.variants[0].available;
      var viq = {};
      productData.variants.forEach(function (v) {
        viq[v.id] = v.available ? 10 : -1;
      });
      window._RestockRocketConfig.variantsInventoryQuantity = viq;
    } catch (e) {
      return;
    }

    var rrSettings = window._RestockRocketConfig.settings || {};
    var btnText = rrSettings.storefront_button_text || 'Auf Warteliste setzen';

    var atcBtn = container.querySelector('#AddToCart');
    if (!atcBtn) return;

    var paymentContainer = atcBtn.closest('product-payment-container');

    var rrContainer = document.createElement('div');
    rrContainer.className = 'quick-atc-rr-container';
    rrContainer.style.cssText = 'display:none;width:100%;';

    var rrBtn = document.createElement('button');
    rrBtn.type = 'button';
    rrBtn.className = 'button button--full quick-atc-rr-button';
    rrBtn.textContent = btnText;
    rrBtn.addEventListener('click', function () {
      if (window._RestockRocket && typeof window._RestockRocket.openModal === 'function') {
        window._RestockRocket.openModal();
      }
    });

    rrContainer.appendChild(rrBtn);
    paymentContainer.parentNode.insertBefore(rrContainer, paymentContainer.nextSibling);

    function syncRR() {
      var variantInput = form.querySelector('[name="id"]');
      if (!variantInput) return;
      var vid = parseInt(variantInput.value, 10);
      var isAvailable = !atcBtn.disabled;

      if (window._RestockRocketConfig) {
        window._RestockRocketConfig.selected_variant_id = vid;
        window._RestockRocketConfig.selected_variant_available = isAvailable;
      }

      if (isAvailable) {
        rrContainer.style.display = 'none';
        paymentContainer.style.display = '';
      } else {
        rrContainer.style.display = 'block';
        paymentContainer.style.display = 'none';
      }
    }

    syncRR();

    form.addEventListener('variant:changed', function () {
      setTimeout(syncRR, 50);
    });
  }

  async function directAddToCart(variantId) {
    var res = await fetch(window.themeVariables.routes.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1, sections: ['mini-cart'] })
    });
    var data = await res.json();
    var cartRes = await fetch(window.themeVariables.routes.cartUrl + '.js');
    var cart = await cartRes.json();
    cart.sections = data.sections;
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { cart: cart, openMiniCart: true }
    }));
  }

  function handleClick(e) {
    var btn = e.target.closest('.quick-atc-icon');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();

      var hasOptions = btn.getAttribute('data-has-options') === 'true';
      if (!hasOptions) {
        var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
        directAddToCart(variantId);
        return;
      }

      var handle = btn.getAttribute('data-product-handle');
      loadContent(handle);
      return;
    }

    if (e.target.closest('.quick-atc-modal__close') || e.target.closest('.quick-atc-modal__overlay')) {
      closeModal();
      return;
    }

    var swatch = e.target.closest('.quick-atc-swatch');
    if (swatch) {
      e.preventDefault();
      var newHandle = swatch.getAttribute('data-handle');
      loadContent(newHandle);
      return;
    }

    var navBtn = e.target.closest('[data-swatch-nav]');
    if (navBtn) {
      var swatchesEl = navBtn.closest('.quick-atc-swatches');
      var list = swatchesEl.querySelector('.quick-atc-swatches__list');
      var scrollAmount = 180;
      if (navBtn.getAttribute('data-swatch-nav') === 'prev') {
        list.scrollLeft -= scrollAmount;
      } else {
        list.scrollLeft += scrollAmount;
      }
      setTimeout(function () { updateSwatchNavArrows(swatchesEl); }, 350);
      return;
    }
  }

  function handleVariantAdded(e) {
    if (modal && modal.classList.contains('quick-atc-modal--open')) {
      closeModal();
    }
  }

  function handleKeydown(e) {
    if (e.key === 'Escape' && modal && modal.classList.contains('quick-atc-modal--open')) {
      closeModal();
    }
  }

  document.body.addEventListener('click', handleClick);
  document.addEventListener('variant:added', handleVariantAdded);
  document.addEventListener('keydown', handleKeydown);
})();
